import React from 'react';

import InputField from '../../../components/inputs/inputField';
import FieldModal from '../../../components/modals/fieldModal';
import ToggleField from '../../../components/inputs/toggleField';
import SelectField from '../../../components/inputs/selectField';
import ViewsTable from '../../../components/tables/ViewsTable';
import moment from 'moment';
import { has } from 'lodash';
const columns = {
    email: 'Email',
    firstName: 'First Name',
    lastName: 'Last Name',
};
const columnTypes = {
    email: 'string',
    firstName: 'string',
    lastName: 'string',
};
const toggledColumns = {};
const normalizedColumns = Object.keys(columns).map((cfc) => {
    toggledColumns[cfc] = true;
    return {
        label: columns[cfc],
        key: cfc,
        value: cfc,
        type: columnTypes[cfc],
        sortAsc: false,
        sortDesc: false
    };
});
class BookedSpotsManagementModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            normalizedColumns,
            toggledColumns,
            submitting: false,
            checkedRegistrants: {},
            registrantsList: [],
            conflictTimeDetails: {},
            hasTimeConflict: false,
            hasBlackoutConflict: false,
            blackoutConflictRegistrants: {},
            registrantsOptions: [],
            overrideRegistrantIds: [],
            overrideSpotIds: [],

        };
    }

    componentDidMount() {
        const { isOpen, selectedTimeSlot, calendar, bookingPage } = this.props;
        let bookedSpots = calendar?.bookedSpots || [];
        let bookedSpotsForSelectedSlot;
        let allRegistrants = bookingPage?.registrants || [];
        let registrantsList = [];
        let checkedRegistrants = {};

        bookedSpotsForSelectedSlot = bookedSpots.filter(spot => {
            let selectedTimeSlotStart = moment(`${selectedTimeSlot.date} ${selectedTimeSlot.startTime}`, 'YYYY-MM-DD h:mm A');
            let selectedTimeSlotEnd = moment(`${selectedTimeSlot.date} ${selectedTimeSlot.endTime}`, 'YYYY-MM-DD h:mm A');
            let spotTime = moment(`${spot.date} ${spot.time}`, 'YYYY-MM-DD h:mm A');

            let registrant = allRegistrants.find(reg => reg.user._id === spot?.user);


            if (spotTime.isSameOrAfter(selectedTimeSlotStart) && spotTime.isSameOrBefore(selectedTimeSlotEnd) && spot.status !== 'canceled' && registrant) {

                checkedRegistrants[registrant._id] = true;
            }

            return spotTime.isSameOrAfter(selectedTimeSlotStart) && spotTime.isSameOrBefore(selectedTimeSlotEnd);
        }).map(spot => {
            let request = bookingPage?.requests?.find(req => req._id === spot.request)
            let registrant = allRegistrants.find(reg => reg._id === request?.registrant)
            return { ...spot, registrant }
        });

        let registrantsOptions = this.props.bookingPage?.registrants?.map(reg => {
            const attendee = reg?.user || { firstName: null, lastName: null };
            let name = attendee.firstName || attendee.lastName ? `${attendee.firstName || ''} ${attendee.lastName || ''}` : 'N/A';
            registrantsList.push({
                ...reg.user,
                email: reg.user?.emailAddress,
                _id: reg._id
            });
            return { label: name, value: reg._id }
        }) || [];

        this.setState({ bookedSpotsForSelectedSlot, registrantsOptions, registrantsList, checkedRegistrants });
    }

    cancelBooking = (bookedSpot) => {
        const { calendar, bookingPage, cancelBooking } = this.props;

        cancelBooking(calendar._id, bookedSpot._id, () => { });
    }


    updatedCheckedRegistrants = (checked) => {
        this.setState({ checkedRegistrants: checked });
    };

    updateBookedSpot = () => {
        const { checkedRegistrants } = this.state;
        const { calendar, bookingPage, updateBookedSpots } = this.props;
        /* we must confirm all checked are not booked in another calendar */
        let allRegistrants = bookingPage?.registrants || [];
        let mappedRegistrants = {};

        allRegistrants.forEach(registrant => {
            mappedRegistrants[registrant.user._id] = registrant;
        });

        let checkedRegistrantsIds = Object.keys(checkedRegistrants);
        let hasTimeConflict = false;
        let hasBlackoutConflict = false;

        let calendars = bookingPage?.calendars || [];
        let conflictTimeDetails = {};
        let blackoutConflictRegistrants = {};

        for (let i = 0; i < calendars.length; i++) {
            let cal = calendars[i];
            let bookedSpots = cal?.bookedSpots || [];

            for (let j = 0; j < bookedSpots.length; j++) {
                let spot = bookedSpots[j];
                let assignedRegistrant = mappedRegistrants[spot.user];

                if (assignedRegistrant && checkedRegistrantsIds.includes(assignedRegistrant._id)) {

                    /* check if time conflict */

                    let selectedTimeSlotStart = moment(`${this.props.selectedTimeSlot.date} ${this.props.selectedTimeSlot.startTime}`, 'YYYY-MM-DD h:mm A');
                    let selectedTimeSlotEnd = moment(`${this.props.selectedTimeSlot.date} ${this.props.selectedTimeSlot.endTime}`, 'YYYY-MM-DD h:mm A');
                    let spotTime = moment(`${spot.date} ${spot.time}`, 'YYYY-MM-DD h:mm A');

                    if (spotTime.isSameOrAfter(selectedTimeSlotStart) &&
                        spotTime.isBefore(selectedTimeSlotEnd) &&
                        cal._id !== calendar._id &&
                        spot.status !== 'canceled') {

                        hasTimeConflict = true;
                        if (!conflictTimeDetails[cal._id]) {
                            conflictTimeDetails[cal._id] = [];
                        }
                        conflictTimeDetails[cal._id].push({
                            _id: assignedRegistrant._id,
                            name: `${assignedRegistrant.user.firstName || ''} ${assignedRegistrant.user.lastName || ''}`,
                            calendarName: cal.name,
                            spotId: spot._id
                        });

                        this.setState({ submitting: false, hasTimeConflict: true, conflictTimeDetails });
                    }


                }
            }
        }


        for (let k = 0; k < checkedRegistrantsIds.length; k++) {
            let registrantId = checkedRegistrantsIds[k];
            let registrant = allRegistrants.find(reg => reg._id === registrantId);
            let reservedDateTimes = registrant?.reservedDateTimes || [];

            for (let m = 0; m < reservedDateTimes.length; m++) {
                let blackOutSlot = reservedDateTimes[m];
                let reservedStart = moment(`${blackOutSlot.startDate} ${blackOutSlot.startTime}`, 'YYYY-MM-DD h:mm A');
                let reservedEnd = moment(`${blackOutSlot.endDate} ${blackOutSlot.endTime}`, 'YYYY-MM-DD h:mm A');

                let selectedTimeSlotStart = moment(`${this.props.selectedTimeSlot.date} ${this.props.selectedTimeSlot.startTime}`, 'YYYY-MM-DD h:mm A');
                let selectedTimeSlotEnd = moment(`${this.props.selectedTimeSlot.date} ${this.props.selectedTimeSlot.endTime}`, 'YYYY-MM-DD h:mm A');

                if ((selectedTimeSlotStart.isBetween(reservedStart, reservedEnd, null, '[)') ||
                    selectedTimeSlotEnd.isBetween(reservedStart, reservedEnd, null, '(]') ||
                    (selectedTimeSlotStart.isSameOrBefore(reservedStart) && selectedTimeSlotEnd.isSameOrAfter(reservedEnd))) &&
                    !this.state.overrideRegistrantIds.includes(registrantId)) {

                    blackoutConflictRegistrants[registrantId] = allRegistrants.find(reg => reg._id === registrantId)?.user || { firstName: 'N/A', lastName: '', emailAddress: '' };
                    hasBlackoutConflict = true;
                }
            }
        }

        this.setState({ hasBlackoutConflict, blackoutConflictRegistrants });



        console.log({ hasBlackoutConflict, blackoutConflictRegistrants });

        if (!hasTimeConflict && !hasBlackoutConflict) {
            this.sendRequest();
        }
    }

    sendRequest = (callback) => {
        const { updateBookedTimeslot } = this.props;

        const payload = {
            registrantIds: Object.keys(this.state.checkedRegistrants),
            overrideSpotIds: this.state.overrideSpotIds,
            calendarId: this.props.calendar._id,
            date: this.props.selectedTimeSlot.date,
            time: this.props.selectedTimeSlot.startTime,
        };
        this.setState({ submitting: true });

        updateBookedTimeslot(payload, () => {
            this.props.toggle();
        });
    }

    render() {
        const { isOpen, toggle, calendar } = this.props;
        const { submitting, normalizedColumns, registrantsList, hasTimeConflict, hasBlackoutConflict, blackoutConflictRegistrants } = this.state;

        return (

            <FieldModal
                size="medium"
                isOpen={isOpen}
                modalTitle={"Booked Spots Management"}
                bodyHeaderText={`${calendar.name} - ${moment(`${this.props.selectedTimeSlot.date} ${this.props.selectedTimeSlot.startTime}`, 'YYYY-MM-DD h:mm A').format('MMM D, YYYY')} ${this.props.selectedTimeSlot.startTime} - ${this.props.selectedTimeSlot.endTime}`}
                bodyDescription={''}
                bodyContent={() => {
                    return (
                        <div className='sectionContainer'>
                            {!hasTimeConflict && !hasBlackoutConflict && (
                                <ViewsTable
                                    style={{ margin: 0, height: 500 }}
                                    columns={normalizedColumns}
                                    toggledColumns={toggledColumns}
                                    data={registrantsList}
                                    mainColumnActive={false}
                                    checked={this.state.checkedRegistrants || {}}
                                    checkRow={(entryId) => {
                                        const checked = this.state.checkedRegistrants;
                                        checked[entryId] ? delete checked[entryId] : (checked[entryId] = true);
                                        this.updatedCheckedRegistrants(checked);
                                        this.setState({
                                            checkedRegistrants: checked
                                        });
                                    }}
                                    mainActions={[]}
                                    checkAllRows={(entryIds) => {
                                        let checked = this.state.checkedRegistrants || {};
                                        entryIds.length > 0
                                            ? entryIds.forEach((entryId) => {
                                                checked[entryId] = true;
                                            })
                                            : (checked = {});
                                        this.updatedCheckedRegistrants(checked);

                                        this.setState({
                                            checkedRegistrants: checked
                                        });
                                    }}
                                    sortData={(column, sortAsc, sortDesc) => { }}
                                />
                            )}

                            {hasTimeConflict && (<div>
                                {Object.keys(this.state.conflictTimeDetails).length === 0 ? (
                                    <div >
                                        <p><strong>All conflicts resolved!</strong> You can now proceed with the booking.</p>
                                    </div>
                                ) : (

                                    <p className="text-danger">There is a time conflict with the selected booking slot. Please resolve the conflict before proceeding.</p>
                                )}

                                <div className="conflict-details mt-15 mb-15">
                                    {Object.keys(this.state.conflictTimeDetails).map((calId, idx) => {
                                        const conflicts = this.state.conflictTimeDetails[calId];
                                        return (
                                            <div key={idx} className="conflict-group mb-15">
                                                {conflicts.map((conflict, conflictIdx) => (
                                                    <div key={conflictIdx} className="neuCard  mb-10" >
                                                        <div className='flex'>
                                                            <div className="conflict-content">
                                                                <p style={{ margin: '0 0 8px 0' }}>
                                                                    <strong >{conflict.name}</strong> is already booked in
                                                                    <strong style={{ marginLeft: '5px', marginRight: '5px' }}>{conflict.calendarName}</strong>calendar.
                                                                </p>
                                                                <p style={{ fontSize: '13px', margin: 0 }}>
                                                                    This booking conflicts with the selected time slot
                                                                </p>
                                                            </div>
                                                            <div className="conflict-actions" style={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                marginLeft: 'auto',
                                                            }}>
                                                                <button
                                                                    className="prim xs"
                                                                    style={{
                                                                        marginRight: '8px',
                                                                        padding: '8px 12px',
                                                                        cursor: 'pointer',
                                                                        fontSize: '13px'
                                                                    }}
                                                                    onClick={() => {
                                                                        let overrideIds = [...this.state.overrideRegistrantIds];
                                                                        overrideIds.push(conflict._id);
                                                                        const conflictDetails = { ...this.state.conflictTimeDetails };

                                                                        // Remove just this conflict from the array
                                                                        conflictDetails[calId] = conflictDetails[calId].filter(c => c._id !== conflict._id);

                                                                        // If no conflicts left for this calendar, remove the calendar entry
                                                                        if (conflictDetails[calId].length === 0) {
                                                                            delete conflictDetails[calId];
                                                                        }

                                                                        let overrideSpotIds = [...this.state.overrideSpotIds];
                                                                        overrideSpotIds.push({ calendarId: calId, spotId: conflict.spotId });
                                                                        this.setState({ overrideSpotIds, overrideRegistrantIds: overrideIds, conflictTimeDetails: conflictDetails });
                                                                    }}
                                                                >
                                                                    Override
                                                                </button>
                                                                <button
                                                                    className="danger xs"
                                                                    style={{
                                                                        padding: '8px 12px',
                                                                        cursor: 'pointer',
                                                                        fontSize: '13px'
                                                                    }}
                                                                    onClick={() => {
                                                                        const checked = { ...this.state.checkedRegistrants };
                                                                        delete checked[conflict._id];
                                                                        const conflictDetails = { ...this.state.conflictTimeDetails };

                                                                        // Remove just this conflict from the array
                                                                        conflictDetails[calId] = conflictDetails[calId].filter(c => c._id !== conflict._id);

                                                                        // If no conflicts left for this calendar, remove the calendar entry
                                                                        if (conflictDetails[calId].length === 0) {
                                                                            delete conflictDetails[calId];
                                                                        }

                                                                        this.setState({ checkedRegistrants: checked, conflictTimeDetails: conflictDetails });
                                                                    }}
                                                                >
                                                                    Skip
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>)}

                            {hasBlackoutConflict && (
                                <div>

                                    {Object.keys(blackoutConflictRegistrants).length === 0 ? (
                                        <div >
                                            <p><strong>All conflicts resolved!</strong> You can now proceed with the booking.</p>
                                        </div>
                                    ) : (
                                        <p className="text-danger">There are blackout conflicts with the selected booking slot. Please resolve the conflict before proceeding.</p>
                                    )}

                                    <div className="conflict-details mt-15 mb-15">
                                        {Object.keys(blackoutConflictRegistrants).map((registrantId) => {
                                            const registrant = blackoutConflictRegistrants[registrantId];
                                            return (
                                                <div key={registrantId} className="neuCard mb-10">
                                                    <div className='flex'>
                                                        <div className="conflict-content">
                                                            <p style={{ margin: '0 0 8px 0' }}>
                                                                <strong>{registrant.firstName} {registrant.lastName}</strong>
                                                                <span style={{ marginLeft: '5px' }}>({registrant.emailAddress})</span>
                                                            </p>
                                                            <p style={{ fontSize: '13px', margin: 0 }}>
                                                                Has a blackout date that conflicts with the selected time slot
                                                            </p>
                                                        </div>
                                                        <div className="conflict-actions" style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            marginLeft: 'auto',
                                                        }}>

                                                            <button
                                                                className="danger xs"
                                                                style={{
                                                                    padding: '8px 12px',
                                                                    cursor: 'pointer',
                                                                    fontSize: '13px'
                                                                }}
                                                                onClick={() => {
                                                                    const checked = { ...this.state.checkedRegistrants };
                                                                    delete checked[registrantId];
                                                                    const updatedBlackoutConflicts = { ...blackoutConflictRegistrants };
                                                                    delete updatedBlackoutConflicts[registrantId];
                                                                    this.setState({
                                                                        checkedRegistrants: checked,
                                                                        blackoutConflictRegistrants: updatedBlackoutConflicts,
                                                                    });
                                                                }}
                                                            >
                                                                Skip
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            )}
                        </ div>)
                }}
                toggle={toggle}
                actionButtonLabel={!submitting ? 'Update' : 'Updating...'}
                actionButton={() => {
                    if (hasTimeConflict || hasBlackoutConflict) {
                        this.sendRequest();
                    } else {
                        this.updateBookedSpot();
                    }
                }}
                actionButtonDisabled={submitting ||
                    (hasTimeConflict && Object.keys(this.state.conflictTimeDetails).length > 0) ||
                    (hasBlackoutConflict && Object.keys(blackoutConflictRegistrants).length > 0)}
            ></FieldModal>
        );
    }
}

export default BookedSpotsManagementModal;
